import commonPostTypeConfig from "../../common/postTypes/file";

export default function initPostType({wapp}) {
    return wapp.client.postTypes.getPostType({
        name: "file",
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager(),
    });
}
